import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { LocalStorageService } from './local-storage';
import { AuthResponse } from 'src/models/auth-response.model';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export abstract class HttpAPIService {
	private authHeaderName = 'Authorization';
	private authTokenPrefix = 'Bearer ';
	private authTokenStorageEntity = 'authtokens';

    constructor(private http: HttpClient, private localStorage: LocalStorageService) { }

    async getWithoutAuthAndContentType(url) {
        const headers = new HttpHeaders();
        return await this.http.get(url, { headers }).toPromise();
    }

    async getWithoutAuth<T>(url, transformJSON = true) {
        let headers = new HttpHeaders();
        headers = headers.append('Content-Type', 'application/json');
        return await this.http.get<T>(url, { headers }).toPromise();
    }

    async postWithoutAuth<T>(url, data = undefined) {
        let headers = new HttpHeaders();
        headers = headers.append('Content-Type', 'application/json');
        return await this.http.post<T>(url, data, { headers }).toPromise();
    }

    async getWithAuth<T>(url) {
        const tokens = await this.localStorage.getEntity<AuthResponse>(this.authTokenStorageEntity);
        // console.log('TOKEN', tokens);
        let headers = new HttpHeaders();
        headers = headers.append('Content-Type', 'application/json');
        headers = headers.append(this.authHeaderName, this.authTokenPrefix + tokens.accessToken);
        headers = headers.append('AppVersion', environment.appVersion);
        // try {
        return await this.http.get<T>(url, { headers }).toPromise();
        // } catch (error) {
        //     if (error.status == '401')
        //         // this.events.publish(EventNames.userLoginRequired);
        //     else {
        //         throw error;
        //     }
        // }
    }

    async postWithAuthAndContentType<T>(url, data = undefined) {
        const tokens = await this.localStorage.getEntity<AuthResponse>(this.authTokenStorageEntity);
        let headers = new HttpHeaders();
        headers = headers.append(this.authHeaderName, this.authTokenPrefix + tokens.accessToken);
        headers = headers.append('AppVersion', environment.appVersion);
        return await this.http.post<T>(url, data, { headers }).toPromise();
        // if (error.status == '401') {
        //     this.events.publish(EventNames.userLoginRequired);
        // } else {
        //     reject(error);
        // }
    }

    async postWithAuth<T>(url, data = undefined, includeContentType = true, responseType = null) {
        const tokens = await this.localStorage.getEntity<AuthResponse>(this.authTokenStorageEntity);
        let headers = new HttpHeaders();
        if (includeContentType) {
            headers = headers.append('Content-Type', 'application/json');
        }
        headers = headers.append(this.authHeaderName, this.authTokenPrefix + tokens.accessToken);
        // console.log('AppVersion', environment.appVersion);
        headers = headers.append('AppVersion', environment.appVersion);
        const options = { headers } as any;
        if (responseType) {
            return await this.http.post<T>(url, data, { headers, responseType }).toPromise();
        } else {
            return await this.http.post<T>(url, data, { headers }).toPromise();
        }
        // if (error.status == '401') {
        //     this.events.publish(EventNames.userLoginRequired);
        // } else {
        //     reject(error);
        // }
    }

    async patchWithAuth<T>(url, data = undefined) {
        const tokens = await this.localStorage.getEntity<AuthResponse>(this.authTokenStorageEntity);
        let headers = new HttpHeaders();
        headers = headers.append('Content-Type', 'application/json');
        headers = headers.append(this.authHeaderName, this.authTokenPrefix + tokens.accessToken);

        return await this.http.patch<T>(url, data, { headers }).toPromise();
        // if (error.status == '401') {
        //     this.events.publish(EventNames.userLoginRequired);
        // } else {
        //     reject(error);
        // }
    }

    async putWithAuth<T>(url, data = undefined, transformJSON = true) {
        const tokens = await this.localStorage.getEntity<AuthResponse>(this.authTokenStorageEntity);
        let headers = new HttpHeaders();
        headers = headers.append('Content-Type', 'application/json');
        headers = headers.append(this.authHeaderName, this.authTokenPrefix + tokens.accessToken);
        return await this.http.put<T>(url, data, { headers }).toPromise();
            // if (error.status == '401') {
            //     this.events.publish(EventNames.userLoginRequired);
            // } else {
            //     reject(error);
            // }
    }

    async putWithoutAuth<T>(url, data = undefined) {
        const tokens = await this.localStorage.getEntity<AuthResponse>(this.authTokenStorageEntity);
        let headers = new HttpHeaders();
        headers = headers.append('Content-Type', 'application/json');
        return await this.http.put(url, data, { headers }).toPromise();
    }

    async deleteWithAuth<T>(url) {
        const tokens = await this.localStorage.getEntity<AuthResponse>(this.authTokenStorageEntity);
        let headers = new HttpHeaders();
        headers = headers.append('Content-Type', 'application/json');
        headers = headers.append(this.authHeaderName, this.authTokenPrefix + tokens.accessToken);

        await this.http.delete(url, { headers }).toPromise();
    }
}
